// @COFIXME: popularCategoriesV2 always links to www.saba.com.au

import CategoriesSection from '../../../components/organisms/categoriesSection/CategoriesSection';
import CategoriesSectionCenteredCarousel from '../../../components/organisms/categoriesSection/CategoriesSectionCenteredCarousel';
import CategoriesSectionGrid from '../../../components/organisms/categoriesSection/CategoriesSectionGrid';
import CategoriesSectionFeaturedCarousel from '../../../components/organisms/categoriesSection/CategoriesSectionFeaturedCarousel';
import { useDevicesScreen } from '../../../utils/useDevicesScreen';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import PropTypes from 'prop-types';
import React from 'react';
import CategoriesSectionAutoplayCarousel from '../../../components/organisms/categoriesSection/CategoriesSectionAutoplayCarousel';

const PopularCategoriesTasticV2 = ({ data, context }) => {
  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  const {
    showSliderArrowsMobile,
    showSliderArrowsTablet,
    showSliderArrowsDesktop,
    sectionType,
    ...rest
  } = data;
  const { isMobile, isTablet, isDesktop, isLargeDesktop } = useDevicesScreen();

  const showSliderArrows = {
    [isMobile]: showSliderArrowsMobile,
    [isTablet]: showSliderArrowsTablet,
    [isDesktop || isLargeDesktop]: showSliderArrowsDesktop,
  }[true];

  if (sectionType === 'staticGrid') {
    return <CategoriesSectionGrid isArrowRight={showSliderArrows} {...rest} />;
  }

  if (sectionType === 'staticAutoplayCarousel') {
    return (
      <CategoriesSectionAutoplayCarousel
        isArrowRight={showSliderArrows}
        {...rest}
      />
    );
  }

  if (sectionType === 'centeredCarousel') {
    return (
      <CategoriesSectionCenteredCarousel
        isArrowRight={showSliderArrows}
        {...rest}
      />
    );
  }

  if (sectionType === 'featuredCarousel') {
    return (
      <CategoriesSectionFeaturedCarousel
        isArrowRight={showSliderArrows}
        {...rest}
      />
    );
  }

  return <CategoriesSection isArrowRight={showSliderArrows} {...rest} />;
};

PopularCategoriesTasticV2.propTypes = {
  data: PropTypes.object.isRequired,
};

export default tastify({
  connect: { context: true },
  translate: true,
})(PopularCategoriesTasticV2);
